import React from 'react';
import {connect} from 'react-redux';
import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";
import IndicatorUtils from "../../utils/IndicatorUtils";
import Spinner from "qwc2/components/widgets/Spinner";
import axios from "axios";
import isEmpty from 'lodash.isempty';
import {addLayerFeatures, LayerRole, removeLayer} from "qwc2/actions/layers";
import ConfigUtils from "qwc2/utils/ConfigUtils";
import FeatureUtils from "../../utils/FeatureUtils";
import {addForIndicators, highlightSelected, removeForIndicators} from "../../actions/indicators";

class IndicatorCompare extends React.Component {
    static propTypes = {
        addForIndicators: PropTypes.func,
        addLayerFeatures: PropTypes.func,
        highlightSelected: PropTypes.func,
        removeForIndicators: PropTypes.func,
        removeLayer: PropTypes.func,
        selectedDate: PropTypes.string,
        selectedIndicator: PropTypes.object,
        selectedObjectType: PropTypes.string,
        selectedObjects: PropTypes.array
    }
    static defaultProps = {}

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            isLoading: true,
            url: null
        };
    }

    updateChart() {
        const url = IndicatorUtils.getDataUrl(this.props.selectedIndicator, this.props.selectedObjectType, this.props.selectedDate);
        const self = this;
        axios(url).then(response => {
            self.setState({
                data: response.data,
                isLoading: false,
                url: url
            });
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    componentDidMount() {
        this.updateChart();
    }

    componentDidUpdate() {
        const url = IndicatorUtils.getDataUrl(this.props.selectedIndicator, this.props.selectedObjectType, this.props.selectedDate);
        if (url !== this.state.url) {
            this.updateChart();
        }
    }

    render() {
        return (
            <div>
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                    </div>
                }
                {!this.state.isLoading &&
                    <div>
                        {this.renderChart()}
                    </div>
                }
            </div>
        );
    }

    highlight = (item) => {
        if (item && item.geometry) {
            // copy, the item may belong to the redux state
            const results = [{...item, crs: 'EPSG:4326'}];
            if (!isEmpty(results)) {
                this.props.removeLayer("identifyslection");
                const layer = {
                    id: "identifyslection",
                    role: LayerRole.SELECTION
                };
                this.props.addLayerFeatures(layer, results, true);
            } else {
                this.props.removeLayer("identifyslection");
            }
        }
    }

    renderChart() {
        const onChartClick = (params) => {
            const data = {...params.data.feature};
            const url = ConfigUtils.getConfigProp("featureServiceUrl") + '/' + data.properties.linkedObjectType + '/items/' + data.properties.linkedObjectUuid;
            axios(url).then(response => {
                const linkedObject = FeatureUtils.getSingleFeature(response.data);
                if (linkedObject) {
                    data.linkedObject = linkedObject;

                    let isSelected = false;
                    if (this.props.selectedObjects) {
                        this.props.selectedObjects.forEach(so => {
                            if (so.properties.id == data.properties.id) {
                                isSelected = true;
                            }
                        });
                    }
                    if (isSelected) {
                        this.props.removeForIndicators(data);
                    } else {
                        this.props.addForIndicators(data);
                    }
                    this.props.highlightSelected();
                } else {
                    console.log('Returned no feature', url);
                }
            }).catch(error => {
                console.log("Error *** : " + error);
            });
        };
        const onChartDblClick = (params) => {
            // console.log('Chart double clicked', params);
        };
        const onChartOver = (params) => {
            if (params.data.feature) {
                this.highlight(params.data.feature);
            }
        };

        const selectedIds = [];
        if (this.props.selectedObjects) {
            this.props.selectedObjects.forEach(o => selectedIds.push(o.linkedObject.properties.id));
        }

        const onEvents = {
            click: onChartClick,
            dblclick: onChartDblClick,
            mouseover: onChartOver
        };
        const values = [];
        this.state.data.features.forEach(f => {
            if (f.properties.value) {
                const itemStyle = {};
                if (selectedIds.indexOf(f.properties.linkedObjectUuid) > -1) {
                    itemStyle.color = '#ff0000';
                }
                values.push({
                    value: parseFloat(f.properties.value),
                    name: f.properties.linkedObjectName,
                    itemStyle: itemStyle,
                    feature: f
                });
            }
        });
        const sorted = values.sort(function(a, b) {
            return a.value - b.value;
        });
        const options = {
            tooltip: {
                formatter: function (params) {
                    params = params[0];
                    return `${params.name}<br />
                      ${params.data.value}`;
                },
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            grid: {
                left: 60
            },
            xAxis: {
                type: 'category',
                axisTick: { show: false },
                axisLabel: {
                    show: false
                }
            },
            yAxis: {
                name: this.props.selectedIndicator.unit || '',
                nameLocation: 'middle',
                nameRotate: 90,
                nameGap: 40,
                type: 'value'
            },
            series: [
                {
                    data: sorted,
                    type: 'bar'
                }
            ]
        };
        return (
            <ReactECharts
                lazyUpdate={false}
                notMerge={false}
                onEvents={onEvents}
                option={options}
                opts={{locale: 'DE'}}
            />
        );
    }
}

const selector = (state) => ({
    selectedIndicator: state.indicators.selectedIndicator,
    selectedObjectType: state.indicators.selectedObjectType,
    selectedObjects: state.indicators.selectedObjects,
    selectedDate: state.indicators.selectedDate
});

export default connect(selector, {
    addForIndicators: addForIndicators,
    removeForIndicators: removeForIndicators,
    addLayerFeatures: addLayerFeatures,
    removeLayer: removeLayer,
    highlightSelected: highlightSelected,
})(IndicatorCompare);
